import { styled } from '@mui/joy';

export const TableContainer = styled('div')({
  flex: 1,
  width: '100%',
  height: '100%',
  position: 'relative',
});
